import React from 'react';
import { Card } from '@totalsoft/rocket-ui';
import { Grid, Tooltip, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import ViewList from '@mui/icons-material/ViewList';
import { Autocomplete } from '@totalsoft/rocket-ui';

const CancelOffersGeneralDataComponent = ({
  offerCancelledStates,
  reasons,
  stateList,
  onPropertyChanged,
  onLookupPropertyChanged,
  validation
}) => {
  const { t } = useTranslation();
  return (
    <Card icon={ViewList} title={t('CancelOffers.AdditionalConditions')} iconColor='primary'>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Tooltip title={t('CancelOffers.CheckExpiredFoldersTooltip')}>
            <FormControlLabel
              control={
                <Checkbox
                  color='primary'
                  checked={Boolean(offerCancelledStates.checkExpiredFolders)}
                  onChange={event => onPropertyChanged('checkExpiredFolders', event.target.checked)}
                />
              }
              label={t('CancelOffers.CheckExpiredFolders')}
            ></FormControlLabel>
          </Tooltip>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            fullWidth
            labelKey='documentStateCode'
            valueKey='documentStateId'
            label={t('CancelOffers.CancelledStateCode')}
            value={{
              documentStateId: offerCancelledStates.cancelledStateId,
              documentStateCode: offerCancelledStates.cancelledStateCode
            }}
            isClearable={false}
            isSearchable={true}
            id='state'
            onChange={event => {
              onLookupPropertyChanged('cancelledStateId', 'cancelledStateCode', event?.documentStateId, event?.documentStateCode);
            }}
            options={stateList}
            error={!isValid(validation.cancelledStateCode)}
            helperText={getErrors(validation.cancelledStateCode)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            fullWidth
            labelKey='reasonCode'
            valueKey='reasonId'
            label={t('CancelOffers.OfferReasonCodeForExpiredFolder')}
            value={{
              reasonId: offerCancelledStates.offerReasonIdForExpiredFolder,
              reasonCode: offerCancelledStates.offerReasonCodeForExpiredFolder
            }}
            isClearable={true}
            isSearchable={true}
            options={reasons}
            onChange={event => {
              onLookupPropertyChanged(
                'offerReasonIdForExpiredFolder',
                'offerReasonCodeForExpiredFolder',
                event?.reasonId,
                event?.reasonCode
              );
            }}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

CancelOffersGeneralDataComponent.propTypes = {
  offerCancelledStates: PropTypes.object.isRequired,
  reasons: PropTypes.array,
  stateList: PropTypes.array.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onLookupPropertyChanged: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default CancelOffersGeneralDataComponent;
